document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector("header");
  const siteNav = nav.querySelector(".list-menu--inline");
  const prev = nav.querySelector(".prev");
  const next = nav.querySelector(".next");
  siteNav.addEventListener("scroll", handleScroll);
  function handleScroll() {
    handleArrows();
  }
  function handleArrows() {
    const needsScroll = siteNav.scrollWidth > siteNav.clientWidth;

    if (!needsScroll) {
      prev.classList.remove("show");
      prev.classList.add("hidden");
      next.classList.remove("show");
      next.classList.add("hidden");
      siteNav.classList.add("centered");
      return;
    }
    siteNav.classList.remove("centered");
    if (siteNav.scrollLeft > 0) {
      prev.classList.remove("hidden");
      prev.classList.add("show");
    } else {
      prev.classList.remove("show");
      prev.classList.add("hidden");
    }
    if (siteNav.scrollLeft + siteNav.clientWidth < siteNav.scrollWidth) {
      next.classList.remove("hidden");
      next.classList.add("show");
    } else {
      next.classList.remove("show");
      next.classList.add("hidden");
    }
  }
  prev.addEventListener("click", function () {
    siteNav.scrollBy({
      left: -100,
      behavior: "smooth",
    });
  });
  next.addEventListener("click", function () {
    siteNav.scrollBy({
      left: 100,
      behavior: "smooth",
    });
  });

  handleArrows();
  window.addEventListener("resize", handleArrows);
});
